import React from 'react';

const DemoLinksSection = () => {
  return (
    <section className="py-16 bg-brand-50">
      <div className="max-w-4xl mx-auto px-4 flex flex-col sm:flex-row justify-center items-start gap-8 sm:gap-12">
        
        {/* Standalone Demo Block */}
        <div className="flex flex-col items-center text-center">
          <a 
            href="https://site.gsweb.io/restorevgen"
            target="_blank" 
            rel="noopener noreferrer"
            className="bg-[#6f6af8] hover:bg-[#5b56d8] text-white text-[15px] font-medium py-3.5 px-10 rounded-full shadow-sm transition-all duration-200 hover:-translate-y-0.5 w-64 sm:w-72 flex items-center justify-center"
          >
            Standalone Demo
          </a>
          <p style={{
      fontSize: '15px'
    }} className="mt-4 text-[14px] text-slate-500 font-medium">How it looks when opening QR code</p>
        </div>

        {/* Website Demo Block */}
        <div className="flex flex-col items-center text-center">
          <a 
            href="https://geospaceweb.net/rbdemo2/restoreviewgen/"
            target="_blank" 
            rel="noopener noreferrer"
            className="bg-[#009ccf] hover:bg-[#008ab8] text-white text-[15px] font-medium py-3.5 px-10 rounded-full shadow-sm transition-all duration-200 hover:-translate-y-0.5 w-64 sm:w-72 flex items-center justify-center"
          >Website Widget Demo</a>
          <p style={{
      fontSize: '15px'
    }} className="mt-4 text-[14px] text-slate-500 font-medium">How it looks on your website</p>
        </div>

      </div>
    </section>
  );
};

export default DemoLinksSection;